module.exports = __webpack_public_path__ + "static/media/zone7-plumbing.158ece60.png";